import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import classNames from 'classnames'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'
import Popup, { PopupTrigger } from '@aytm/lib/rfd-ui/components/basic/popup'

export default class InvoiceTableTextRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func
  }

  constructor(...args) {
    super(...args)
    this.toggleCheck = this.toggleCheck.bind(this)
  }

  toggleCheck() {
    const { onChange, row } = this.props
    const id = row.get('id')

    if (id && 'function' == typeof onChange) {
      onChange(
        Map({
          [id]: Map({
            type: 'text',
            value: !row.get('checked')
          })
        }),
        id,
        false !== row.get('update')
      )
    }
  }

  renderText() {
    const { row } = this.props

    const checked = row.get('checked')
    const textHint = row.get('hintText') || row.get('hintNote')
    const isTextHint = Map.isMap(textHint) && textHint.has('text')

    return (
      <div className={row.has('value') && row.get('value') ? 'rfd-ui-invoice-table-dotted' : null}>
        <div className={row.has('value') && row.get('value') ? 'rfd-ui-invoice-table-dotted-text' : null}>
          {null != checked && (
            <i
              className={classNames('rfd-ui-invoice-table-checkbox', {
                'icon-aytmfd-afdcheckbox': !checked,
                'icon-aytmfd-afdcheckbox-full': Boolean(checked)
              })}
              onClick={this.toggleCheck}
            />
          )}
          {this.renderLeveledText(row.get('text'), row.get('level'), 'rfd-ui-invoice-table-row-label-text')}

          {textHint && isTextHint && (
            <PopupTrigger trigger="hover">
              <Popup
                direction={textHint.get('direction') || 'righttop'}
                content={() => (
                  <div>
                    <p>{textHint.get('title') ? textHint.get('title') : ''}</p>
                    <span>{textHint.get('text')}</span>
                  </div>
                )}
                width="208px"
                popupOffset={15}
                borderSize={2}
                borderColor={'#73B0AC'}
              >
                <i key="popupRefEl" className={`icon-aytmfd-${textHint.has('icon') ? textHint.get('icon') : 'help'}`} />
              </Popup>
            </PopupTrigger>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { row, valuesWidth } = this.props
    const width = row.has('value')
      ? this.props.width
      : this.props.width && valuesWidth
        ? this.props.width + valuesWidth
        : null
    const checked = row.get('checked')
    const valueHint = row.get('hintValue')
    const isValueHint = Map.isMap(valueHint) && valueHint.has('text')

    return (
      <div
        className={`rfd-ui-invoice-table-row-bordered-container${
          false === checked ? ' rfd-ui-invoice-table-row-opted-out' : ''
        }`}
      >
        <div className="rfd-ui-invoice-table-row-label" style={{ width: width }}>
          <div className="rfd-ui-invoice-table-text">{this.renderText()}</div>
        </div>
        {row.has('value') && (
          <div className="rfd-ui-invoice-table-row-value" style={{ width: valuesWidth }}>
            <div className="rfd-ui-invoice-table-row-value-text">
              <div
                className="rfd-ui-invoice-table-row-value-text-content"
                dangerouslySetInnerHTML={{ __html: this.preprocessText(row.get('value')) }}
              />
              {isValueHint && (
                <PopupTrigger trigger="hover">
                  <Popup
                    direction={valueHint.get('direction') || 'righttop'}
                    popupOffset={15}
                    borderSize={2}
                    borderColor={'#73B0AC'}
                    width="208px"
                    content={() => (
                      <div>
                        <p>{valueHint.get('title') ? valueHint.get('title') : ''}</p>
                        {valueHint.get('text')}
                      </div>
                    )}
                  >
                    <i
                      key="popupRefEl"
                      className={`icon-aytmfd-${valueHint.has('icon') ? valueHint.get('icon') : 'help'}`}
                    />
                  </Popup>
                </PopupTrigger>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}
